document.addEventListener("DOMContentLoaded", function() {
  /********** SOMETIMES **********/
  if (document.querySelector(".faq__wrapper")) {
    FAQ.init();
  }

  if (document.querySelector(".splide")) {
    SPLIDE.init();
  }

  if (document.querySelector(".b-all-posts__filter")) {
    POSTSFILTER.init();
  }

  if (document.querySelector(".c-sharing")) {
    SOCIALSHARING.init();
  }

  if (document.querySelector("#google-maps")) {
    GOOGLEMAPS.init();
  }

  if (document.querySelector(".b-faq")) {
    FAQ.init();
  }

  /********** ALWAYS **********/
  MENU.init();
});
